import type { JiraIssueRemoteIssueLink } from '../../types';

export const isJiraIssueRemoteIssueLink = (entity: any): entity is JiraIssueRemoteIssueLink =>
	entity.__typename === 'JiraIssueRemoteIssueLink';

export const getJiraIssueRemoteIssueLink = (link: JiraIssueRemoteIssueLink): string | null =>
	link?.href ?? null;
